var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSubscriptionRightIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 14,
    fill: "none",
    viewBox: "0 0 56 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M56 6.759c0 .29-.098.482-.295.675L49.8 13.71c-.197.193-.492.29-.69.29-.196 0-.491-.097-.688-.29-.394-.386-.394-.965-.099-1.351l4.43-4.635H0v-1.93h52.654L48.422 1.64c-.394-.386-.394-.965 0-1.351.394-.387.984-.387 1.378 0l5.905 5.793c.197.193.295.386.295.676z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionRightIcon);
export default __webpack_public_path__ + "static/media/subscription-right-icon.45553de15cd81918714f29d9f91f7cbd.svg";
export { ForwardRef as ReactComponent };